<template>
  <div id="sp" class="sponsors-categories">
    <div
      class="sponsor-category mt-1 mb-2"
      v-for="{ name, id }, index in categories"
      :key="id"
    >
      <div class="sponsorHeading">
        <h3 class="sponsor-font">{{ name }}</h3>
      </div>
      <Sponsors :categoryId="id" :index="index" :categoryName="name" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Sponsors from './Sponsors.vue';

export default {
  components: {
    Sponsors,
  },
  data() {
    return {
      categories: [],
    };
  },
  async mounted() {
    if (this.$route.params.eventId) {
      this.categories = await this.fetchEventCategories(this.$route.params.eventId);
    }
    if (this.$route.params.awardId) {
      this.categories = await this.fetchAwardCategories(this.$route.params.awardId);
    }
  },
  methods: {
    ...mapActions({
      fetchEventCategories: 'events/fetchEventCategories',
      fetchAwardCategories: 'awards/fetchAwardCategories',
      fetchEventSponsors: 'awards/fetchEventSponsors',
      fetchAwardSponsors: 'awards/fetchAwardSponsors',
    }),
  },
};
</script>

<style scoped>
.sponsors-categories {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sponsorHeading {
  text-align: center;
  border-radius: 10px 10px 0 0;
  color: #bd9d5f;
  background-color: #f3f3f3;
  height: 45px;
}
.sponsor-font {
  font-size: 18px;
  text-transform: uppercase;
  line-height: 47px;
}

.sponsor-category {
  width: 100%;
  max-width: 100%;
}

#associate-col {
  height: 50px;
  background: white;
  border-right: 1px solid #e5e5e5;
}
.associateImg {
  width: 100%;
  margin-top: -34px;
}
.platiniumSponsors {
  width: 280px;
  background: rgb(12, 41, 41) !important;
  position: relative !important;
  bottom: 25px;
}
.goldSponsors {
  width: 280px;
  background: rgb(13, 226, 13) !important;
  position: relative !important;
  bottom: 11px;
}
.silverSponsors {
  width: 280px;
  background: rgb(36, 0, 121) !important;
  position: relative !important;
  bottom: 1px;
}
.associateSponsors {
  width: 280px;
  background: rgb(175, 23, 23) !important;
  position: relative !important;
  top: 10px;
}
.mediaPartners {
  width: 280px;
  background: rgb(44, 77, 2) !important;
  position: relative !important;
}
</style>
